
//960x1160px
//recommended PPI: 300
// px formula: 300 / 2.54 * cm

// 300x300 => 960x1160
// 200x200 => 640x574
// 1200x1200 => 640x2574
// 600x600 => 640x1374

// 1height rozdielu prida 2px vysledne
// vysledny rozmer: 
export const sizeOptions = [
  { key: 'xs', value: 'xs', text: 'XS - veľkosť 8x10cm', name: 'XS', pxSize: 200 },
  { key: 's', value: 's', text: 'S - veľkosť 20x30cm', name: 'S', pxSize: 300 },
  { key: 'm', value: 'm', text: 'M - veľkosť 40x50cm', name: 'M', pxSize: 600 },
  { key: 'l', value: 'l', text: 'L - veľkosť 50x80cm', name: 'L', pxSize: 900 },
  { key: 'xl', value: 'xl', text: 'XL - veľkosť 80x120cm', name: 'XL', pxSize: 1800 },
]
